module.exports = __webpack_public_path__ + "img/48.d5fe00b7.jpg";